import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsSingleLevelGroupByRoute: InvariantJiraRoute = {
	name: 'legacy-reports-single-level-group-by-report',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey=com.atlassian.jira.plugin.system.reports:singlelevelgroupby'],
};
